import {useEffect, useState} from 'react';

export const BooleanPartialFieldCustom = (props: any) => {
    const [partial, setPartial] = useState(false);

    useEffect(() => {
        setPartial(props.props.partial);
    }, [props])

    return partial ? (<span style={{ color: "red" }}><b>SI</b></span>) : (<span></span>);
}

BooleanPartialFieldCustom.defaultProps = { label: 'Consegna parziale' };
